import groupListing from './group-listing';

export default function initGroups() {
    groupListing().init();
}
